import { useAuth0 } from '@auth0/auth0-react';
import axios, { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import configuration from '../../configuration';


export function useMailbackDone(
    options?: Omit<
        UseMutationOptions<
            void,
            AxiosError,
            number[]
        >,
        'mutationKey' | 'mutationFn'
    >,
) {
    const { getAccessTokenSilently } = useAuth0();
    return useMutation(
        async (request: number[]) => {
            const token = await getAccessTokenSilently();
            axios.post(`${configuration.apiUrl}/donations/mailback_done`, request, {
                headers: {
                    'authorization': `bearer ${token}`
                }
            });

        }, options
    );
}